export const DocumentTypes = [
    { id: 0, name: undefined },
    { id: 1, name: 'Lease Purchase Report' },
    { id: 2, name: 'Original Lease' },
    { id: 3, name: 'Memo of OGML' },
    { id: 4, name: 'Order of Payment' },
    { id: 5, name: 'Payment Type' },
    { id: 6, name: 'W-9' },
    { id: 7, name: 'Field MOR' },
    { id: 8, name: 'System Generated MOR' },
    { id: 9, name: 'Plat' },
    { id: 10, name: 'Source Deed' },
    { id: 11, name: 'Proof of Payment' },
    { id: 12, name: 'Flowchart'},
    { id: 13, name: 'Runsheet'},
    { id: 14, name: 'Miscellaneous Supporting Doc' },
    { id: 15, name: 'Contractor Information Page' },
    { id: 16, name: 'Landman Affidavit' },
    { id: 17, name: 'Drug Policy' },
    { id: 18, name: 'MVR - Motor Vehicle Record' },
    { id: 19, name: 'Employee New Hire Packet' },
    { id: 20, name: 'Background' },
    { id: 21, name: 'Auto Insurance' },
    { id: 22, name: 'AAPL/IRWA Membership' },
    { id: 23, name: 'Drivers License Expiration' },
    { id: 24, name: 'Scorecard' },
    { id: 25, name: 'Receipt'}
];



// WEBPACK FOOTER //
// ./src/models/DocumentTypes.ts